//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import recursionTab from "@/components/common/recursionTab.vue";
import { getCustom, handlecustomOrRecall as _handlecustomOrRecall } from "@/api/serveCenter/serveCenter";
import { getSubjectVoList, getTopicVoList } from "@/api/serveCenter/serveCenter";
import { getDeptTree } from "@/api/managementCenter/otherApi";
export default {
  name: "searhRidoSelect",
  components: {
    recursionTab: recursionTab
  },
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      loading: false,
      editIng: false,
      id: "",
      isRole: false,
      isServeType: false,
      isSubject: false,
      isTopic: false,
      isDept: false,
      roleList: [{
        name: "教职工",
        value: "0"
      }, {
        name: "学生",
        value: "1"
      }],
      typeList: [{
        name: "查询类",
        value: "0"
      }, {
        name: "审批类",
        value: "1"
      }],
      subjectList: [],
      topicList: [],
      deptList: [],
      roleSelect: "",
      subjectSelect: "",
      topicSelect: "",
      deptSelect: "",
      serveType: ""
    };
  },
  mounted: function mounted() {
    this.emitParams();
    this.getCustomFn();
    this.getSubjectVoListFn();
    this.getTopicVoListFn();
    this.getDeptTreeDataFn();
  },
  methods: {
    changeBack: function changeBack(key, val) {
      if (this.editIng) {
        return;
      }

      this[key] = val;
      this.emitParams();
    },
    emitParams: function emitParams() {
      var obj = {
        serveType: this.serveType,
        role_type: this.roleSelect,
        subject_id: this.subjectSelect,
        topic_id: this.topicSelect,
        dept_id: this.deptSelect
      };
      this.$emit("clickEvent", obj);
    },
    // 获取主题查询列表
    getSubjectVoListFn: function getSubjectVoListFn() {
      var _this = this;

      getSubjectVoList().then(function (_ref) {
        var data = _ref.data;

        if (data.code == 0) {
          _this.subjectList = data.data || [];
        }
      }).catch(function () {});
    },
    // 获取专题查询列表
    getTopicVoListFn: function getTopicVoListFn() {
      var _this2 = this;

      getTopicVoList().then(function (_ref2) {
        var data = _ref2.data;

        if (data.code == 0) {
          _this2.topicList = data.data || [];
        }
      }).catch(function () {});
    },
    getDeptTreeDataFn: function getDeptTreeDataFn() {
      var _this3 = this;

      getDeptTree().then(function (_ref3) {
        var data = _ref3.data;

        if (data.code == 0) {
          if (data.data && data.data.length > 0) {
            _this3.deptList = data.data[0].children; // console.log(this.deptList)

            _this3.deptList.unshift({
              id: "",
              name: "全校"
            });
          } else {
            _this3.deptList = [{
              id: "",
              name: "全校"
            }];
          }
        }
      }).catch(function (err) {});
    },
    getCustomFn: function getCustomFn() {
      var _this4 = this;

      getCustom().then(function (_ref4) {
        var data = _ref4.data;

        if (data.code == 0) {
          if (data.data) {
            // console.log(data.data)
            _this4.isRole = data.data.isRole;
            _this4.isSubject = data.data.isSubject;
            _this4.isTopic = data.data.isTopic;
            _this4.isDept = data.data.isDept;
            _this4.isServeType = true;
            _this4.id = data.data.id;
          } else {
            _this4.isServeType = true;
            _this4.isRole = true;
            _this4.isSubject = true;
            _this4.isTopic = true;
            _this4.isDept = true;
          }
        }
      }).catch(function (err) {});
    },
    handlecustomOrRecall: function handlecustomOrRecall() {
      var _this5 = this;

      this.loading = true;
      var params = {
        id: this.id,
        isDept: this.isDept ? 1 : 0,
        isSubject: this.isSubject ? 1 : 0,
        isRole: this.isRole ? 1 : 0,
        isServeType: this.isServeType ? 1 : 0,
        isTopic: this.isTopic ? 1 : 0,
        userId: this.$store.getters.userData.userId
      };

      _handlecustomOrRecall(params).then(function (_ref5) {
        var data = _ref5.data;
        _this5.loading = false;

        if (data.code == 0) {
          _this5.$message.success("设置搜索项成功！");

          _this5.editIng = false;
        } else {
          _this5.$message.warning(data.msg || "设置搜索项失败！");
        }
      }).catch(function (err) {
        _this5.loading = false;

        _this5.$message.error("服务异常");
      });
    },
    selectDept: function selectDept(item) {
      this.deptSelect = item.id + "";
      this.emitParams();
    },
    useHandle: function useHandle(key) {
      console.log(key, "key");
      this[key] = !this[key];
    }
  },
  watch: {
    editIng: function editIng() {
      this.roleSelect = "";
      this.subjectSelect = "";
      this.topicSelect = "";
      this.deptSelect = "";
    }
  }
};